// src/data/serviceList.js
// Single source of truth for where services are LISTED: navbar dropdown,
// homepage carousel, and /services page. Kept separate from services.js
// (full detail page content) so the navbar doesn't ship that data on every page.
//
// Fields:
//   slug        -> URL at /services/<slug> (must match a slug in services.js)
//   title       -> full name, shown on the /services page
//   shortTitle  -> optional shorter name for navbar + homepage (falls back to title)
//   description -> blurb on the /services page
//   icon        -> light icon (dark backgrounds: /services page)
//   iconDark    -> dark icon (light backgrounds: homepage carousel)
//   comingSoon  -> true = greyed out, "Coming Soon" label, not clickable, everywhere
//   featured    -> true = moved to the top of every list (e.g. in-season services).
//                  Remove it when the season ends and it drops back to its normal spot.
//   packages    -> package names for the quote form's Package dropdown. Must match
//                  the package names in services.js exactly (that's how the
//                  "Choose Your Package" cards pre-select them).
//
// Order here is the order shown everywhere, except featured services go first.

const serviceList = [
  {
    slug: "detailing",
    title: "Detailing",
    packages: ["Standard In & Out", "Premium In & Out"],
    description:
      "A complete top-to-bottom restoration combining deep interior sanitization with a meticulous exterior wash and protection.",
    icon: "/images/icons/exteriordetailing.png",
    iconDark: "/images/icons/exteriordetailingdark.png",
  },
  {
    slug: "paint-correction",
    title: "Paint Correction",
    description:
      "Expert polishing to remove swirl marks, scratches, and paint defects, restoring a flawless finish.",
    icon: "/images/icons/paintcorrection.png",
    iconDark: "/images/icons/paintcorrectiondark.png",
  },
  {
    slug: "ceramic-coating",
    title: "Ceramic Coating",
    description:
      "High-gloss, long-lasting ceramic coatings that protect your vehicle's paint from contaminants and damage.",
    icon: "/images/icons/ceramiccoating.png",
    iconDark: "/images/icons/ceramiccoatingdark.png",
  },
  {
    slug: "ppf",
    title: "PPF",
    description:
      "High-performance clear film engineered to shield your factory paint from rock chips, scratches, and road debris with advanced self-healing technology.",
    icon: "/images/icons/ppf.png",
    iconDark: "/images/icons/ppfdark.png",
  },
  {
    slug: "vinyl-wrap",
    title: "Vinyl Wrap",
    description:
      "Transform your vehicle’s look with a premium color change and custom finish while adding a reversible layer of protection to your original paint.",
    icon: "/images/icons/vinylwrap.png",
    iconDark: "/images/icons/vinylwrapdark.png",
  },
  {
    slug: "window-tinting",
    title: "Window Tinting",
    description:
      "Professionally installed tints to reduce glare, improve privacy, and protect your interior from UV rays.",
    icon: "/images/icons/windowtint.png",
    iconDark: "/images/icons/windowtintdark.png",
  },
  {
    slug: "vehicle-graphics",
    title: "Custom Graphics & Decals",
    shortTitle: "Vehicle Graphics",
    description:
      "Vinyl decals and vehicle graphics for personal style or business branding, professionally designed and installed.",
    icon: "/images/icons/vehiclegraphics.png",
    iconDark: "/images/icons/vehiclegraphicsdark.png",
  },
  {
    slug: "tire-swaps",
    title: "Tire Sales & Swaps",
    featured: true,
    packages: [
      "Seasonal Changeover",
      "Mount, Balance & Install",
      "Tire & Rim Sales",
    ],
    description:
      "New tires, steel rims, mounting, balancing, and seasonal changeovers to keep your ride ready year-round.",
    icon: "/images/icons/tireswap.png",
    iconDark: "/images/icons/tireswapdark.png",
  },
]

// Featured first; otherwise keeps the order above.
module.exports = [
  ...serviceList.filter(s => s.featured),
  ...serviceList.filter(s => !s.featured),
]
